module.exports = __webpack_public_path__ + "img/eeia-logo.8381ebb4.png";